import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';
import axios from 'axios';

const ApprovalCodeList = () => {
  
  // Function to handle employee change, set the role based on the selected employee
  const handleEmployeeChange = (value, formData, setFormData,name) => {
    // retrieve the role of the employee based on the selected employee using the employee_id and axios
    const employeeId = value;
    axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/hospital-portal/api/employees/byID/${employeeId}`)
      .then(response => {
        const employee = response.data;
        // Assuming the role is in the employee object
        setFormData(prev => ({
          ...prev,
          role: employee.role,
        }));
      })
      .catch(error => {
        console.error('Error fetching employee data:', error);
      });    

  };
  
    const apiConfig = new ApiConfigFactory('employees/approval-codes', 'Approval Codes');
  apiConfig.defaultSortAsc = false;
  apiConfig.defaultSortFieldId = 'id';
  apiConfig.path = '/employee-access-codes';
  apiConfig.allowAdd = true;  

  apiConfig
    .addField({ name: 'id', label: 'ID', type: 'text', identifier: true, visible: false, tab: 'Main' })
    .addField({ name: 'employee_id', label: 'Employee', type: 'dropdown', required: true, tab: 'Main', onChange: handleEmployeeChange })
    .addField({ name: 'role', label: 'Role', type: 'text', required: true, tab: 'Main' })
    .addField({ name: 'security_code', label: 'Security Code', type: 'text', required: true, tab: 'Main' })
    .addField({ name: 'status', label: 'Active', type: 'checkbox', tab: 'Main' })

    .addDropdownField({
      name: 'employee_id',
      endpoint: '/hospital-portal/api/employees',
      valueField: 'employee_id',
      labelField: 'employee_name',
    })

    .addColumn({ id: 'id', name: 'ID', selector: (row) => row.id, sortable: true })
    .addColumn({ name: 'Employee', selector: (row) => row.Employee?.employee_name, sortable: true,filterable: true,filterSelector: 'Employee.employee_name' })
    .addColumn({ name: 'Role', selector: (row) => row.Employee?.role, sortable: true,filterable: true,filterSelector: 'Employee.role' })
    .addColumn({ name: 'Status', selector: (row) => row.status ? 'Active' : 'Inactive', sortable: true });

  return <DataList apiConfig={apiConfig} columns={apiConfig.columns} />;
};

export default ApprovalCodeList;
